import React from "react";
import "./About.scss";
import {FooterFixed} from "../../components/FooterFixed";
import Woman from "./imgs/woman.jpg"
import {useFixedHeader} from "../../utils/headerHelper";
import {SubmitInfo} from "../../components/SubmitInfo/SubmitInfo";
import {BlackModal} from "../../components/BlackModal/BlackModal";
import intl from "react-intl-universal";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../locales/config";

export function About() {

    useFixedHeader();

    const isCN = LOCALES_HELPER.getLan() === DEFAULT_LOCALE;

    return <>
        <main className="main-content">
            <header className="page-header large image-background about-header-bg dark-color center no-padding">
                    <div className="container v-align-center">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="x-large">{intl.get('aboutUs')}</h1>
                                <div>
                                    <i className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i><i className="icon-glyph-10 medium"></i><i
                                    className="icon-glyph-10 medium"></i>
                                </div>
                            </div>
                        </div>
                    </div>
            </header>

            <section className="pt-small pb-small light-color" data-nekoanim="fadeInUp" data-nekodelay="100">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-6 col-sm-push-6 col-md-8 col-md-push-4 cus-mt">
                            <h1>{isCN && <span>our mission</span>}{intl.get('our-misson')}</h1>
                            <p className="mission-detail">
                                {intl.get('mission-detail')}
                            </p>
                            {/*<a href="#" className="btn large default">Buy now!</a>*/}
                        </div>
                        <div className="col-sm-6 col-sm-pull-6 col-md-4 col-md-pull-8">
                            <img style={{maxHeight: '300px'}} src={Woman} className="responsive" alt=""/>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <article className="light-color section-fw">
                    <div className="container-fw align-center">
                        <div className="row">
                            <div
                                className="col-md-6 col-md-6-push image-background image-fw-right cover no-padding news-2">
                            </div>

                            <div className="col-md-6 col-md-6-pull padding-large">
                                <h1>{isCN && <span>our background</span>}{intl.get('our-background')}</h1>
                                <p className="font-16">
                                    {intl.get('background-detail')}
                                </p>
                                {/*<a href="#" className="btn default small border">了解更多</a>*/}
                            </div>


                        </div>

                    </div>

                </article>
                <article className="light-color section-fw">
                    <div className="container-fw align-center">
                        <div className="row">
                            <div className="col-md-6 image-background cover no-padding news-4">
                            </div>
                            <div className="col-md-6 col-md-offset-6 padding-large">
                                <h1>{isCN && <span>Geographical advantage</span>}{intl.get('dyys')}</h1>
                                <p className="font-16">
                                    {intl.get('dlys-detail')}
                                </p>
                                {/*<a href="#" className="btn default small border">Read more</a>*/}
                            </div>
                        </div>
                    </div>
                </article>
                <article className="light-color section-fw">
                    <div className="container-fw align-center">
                        <div className="row">
                            <div
                                className="col-md-6 col-md-6-push image-background image-fw-right cover no-padding product-star">
                            </div>

                            <div className="col-md-6 col-md-6-pull padding-large">
                                <h1>{isCN && <span>Star Products</span>}{intl.get('mxcp')}</h1>
                                <p className="font-16">
                                    {intl.get('star-product')}
                                </p>
                                {/*<a href="#" className="btn default small border">了解更多</a>*/}
                            </div>


                        </div>

                    </div>

                </article>
                <article className="light-color section-fw">
                    <div className="container-fw align-center">
                        <div className="row">
                            <div className="col-md-6 image-background cover no-padding news-3">
                            </div>
                            <div className="col-md-6 col-md-offset-6 padding-large">
                                <h1>{isCN && <span>our team</span>}{intl.get('wmdtd')}</h1>
                                <p className="font-16">
                                    {intl.get('our-team')}
                                </p>
                                {/*<a href="#" className="btn default small border">Read more</a>*/}
                            </div>
                        </div>
                    </div>
                </article>
            </section>

            <section id="services" className="pt-medium pb-medium light-color">
                <div className="container">
                    <div className="row">
                        <h1 style={{textAlign: 'center'}}>{isCN && <span>our advantage</span>}{intl.get('our-advantage')}</h1>
                    </div>
                    <div className="row">

                        <div className="col-md-3 col-sm-6">
                            <article className="box-icon font-16">
                                <a>
                                    <i className="icon-glyph-263 large circle animated"></i>
                                    <h3>ISO</h3>
                                    <p>{intl.get('iso')}</p>
                                </a>
                            </article>
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <article className="box-icon font-16">
                                <a>
                                    <i className="icon-glyph-247 large circle animated"></i>
                                    <h3>CE</h3>
                                    <p>{intl.get('ce')}</p>
                                </a>
                            </article>
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <article className="box-icon font-16">
                                <a>
                                    <i className="icon-glyph-72 large circle animated"></i>
                                    <h3>CFDA</h3>
                                    <p>{intl.get('cfda')}</p>
                                </a>
                            </article>
                        </div>

                        <div className="col-md-3 col-sm-6">
                            <article className="box-icon font-16">
                                <a>
                                    <i className="icon-glyph-228 large circle animated"></i>
                                    <h3>30 +</h3>
                                    <p>{intl.get('30+')}</p>
                                </a>
                            </article>
                        </div>

                    </div>
                </div>
            </section>
            <SubmitInfo/>
            <BlackModal/>
        </main>
        <FooterFixed/>
    </>
}
